
import { computed, defineComponent, PropType, ref } from "vue";
import { DropdownOption } from "@/models/DropdownOption";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default defineComponent({
  inheritAttrs: false,
  components: {
    Multiselect,
  },
  emits: ["clear", "close", "update:modelValue"],
  props: {
    name: String,
    modelValue: [String, Array, Number, Date],
    options: Array as PropType<DropdownOption[]>,
    hasError: {
      type: Boolean,
      required: false,
    },
    errors: {
      type: Array,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    valid: {
      type: Boolean,
      required: false,
    },
    searchable: {
      type: Boolean,
      required: false,
    },
    canClear: {
      type: Boolean,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    mode: {
      type: String,
      default: "single",
    },
    insideLabel: {
      type: String,
      required: false,
    },
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    getMultipleLabel: {
      type: Function,
      required: false,
    },
    next: {},
  },
  setup(props, { emit }) {
    const inputValue = computed({
      get(): any {
        return props.modelValue;
      },
      set(value: any) {
        emit("update:modelValue", value);
      },
    });

    const active = ref(false);

    const onFocus = () => {
      active.value = true;
    };

    const onBlur = () => {
      active.value = !!inputValue.value;
      emit("close");
    };

    const onClear = () => {
      emit("clear");
    };

    const select = ref();
    const open = () => {
      select.value?.open();
    };

    return {
      inputValue,
      onFocus,
      onBlur,
      active,
      select,
      onClear,
      open,
    };
  },
});
